export const toggleInArray = <A>(selected: A, data: A[]) =>
  data.includes(selected) ? data.filter((item) => item !== selected) : data.concat(selected);
